<div class="dialogContainer">
  <div class="content">
    <p>The estimated lead time is per release. Parameters for determining this lead time include:</p>
    <div class="bulletList">
      <ol type="i">
        <li>Number of unique configurations</li>
        <li>Combination of SFRs and Line Items</li>
        <li>SFRs for Sureflow and Customer Furnished components.</li>
      </ol>
    </div>
    <div class="entityInformation">
      <p>Information for this {{ entityType }}:</p>
      <div class="bulletList">
        <ol type="a">
          <li>Number of unique configurations: {{ distinctConfigurations }}</li>
          <li>Average number of SFRs per line: {{ averageSfrCount }}</li>
        </ol>
      </div>
    </div>
    <div class="buttonBar">
      <div class="spacer"></div>
      <button class="primary-button" matButton="elevated" (click)="close()">Close</button>
    </div>
  </div>
</div>
